(() => {
  "use strict";

  function initProductSlider(initAll = false) {
    // Define a generic function to initialize a slider
    const initializeSlider = (sliderElement) => {
      const numberOfSlides = sliderElement.querySelectorAll(".splide__slide").length;
      const spMode = sliderElement.getAttribute("data-sp-mode");
      let splideOptions;

      if (spMode === "loop") {
        splideOptions = {
          type: "slide",
          rewind: true,
          autoplay: false,
          snap: false,
          focus: 0,
          perPage: 1,
          autoWidth: true,
          pagination: false,
          arrows: false,
          gap: "28px",
          trimSpace: true,
          drag: numberOfSlides < 2 ? false : true,
          breakpoints: {
            767: {
              type: "loop",
              snap: true,
              flickPower: 100,
              clones: numberOfSlides < 3 ? 0 : undefined,
              gap: "15px",
              focus: "center",
              perPage: 1,
            },
          },
        };
      } else {
        splideOptions = {
          type: "slide",
          rewind: true,
          autoplay: false,
          snap: false,
          focus: 0,
          perPage: 1,
          autoWidth: true,
          pagination: false,
          arrows: false,
          gap: "28px",
          trimSpace: true,
          drag: numberOfSlides < 2 ? false : true,
          breakpoints: {
            767: {
              flickPower: 100,
            },
          },
        };
      }

      const splide = new Splide(sliderElement, splideOptions);

      const progressBar = sliderElement.querySelector(".product-slider__progress-bar");

      // Updates the bar width whenever the carousel moves
      splide.on("mounted move", function () {
        const end = splide.Components.Controller.getEnd() + 1;
        const rate = Math.min((splide.index + 1) / end, 1);
        progressBar.style.width = String(100 * rate) + "%";
      });

      splide.mount();
    };

    if (initAll) {
      const sliderElements = document.querySelectorAll(".product-slider__splide");
      sliderElements.forEach(sliderElement => initializeSlider(sliderElement));
    } else {
      const currentScript = document.currentScript;
      const sectionId = currentScript.id;
      const sliderElement = document.querySelector(`.product-slider__splide[data-section-id="${sectionId}"]`);
      if (sliderElement) {
        initializeSlider(sliderElement);
      }
    }
  }

  // Initially call for the current script
  initProductSlider();

  // Adjust the event listener to initialize all sliders on section load
  document.addEventListener('shopify:section:load', () => initProductSlider(true));
})();
